import { Component } from '@angular/core';
import { LayoutModule } from '../../../layout/layout.module';
import { MessagingModule } from '../../../../messaging/messaging.module';

@Component({
  selector: 'app-telegram-dashboard-page',
  standalone: true,
  imports: [
    LayoutModule,
    MessagingModule,
  ],
  templateUrl: './telegram-dashboard-page.component.html',
})
export class TelegramDashboardPageComponent { }
